<template>
    <div class='container'>
        <div class='columns'>
            <!-- <div class='column is-3'>
                <checklist title="Getting started" :items="checklist"></checklist>
            </div> -->
            <div class='column is-12'>

                <h3 class='subtitle is-4'>University spotlights</h3>

                <div class='columns'>
                    <div class='column' v-for="post in universitySpotlights" :key="post.id">
                        <div class='columns'>
                            <div class='column'>
                                <project-card :project="post.highlightedProject"></project-card>
                            </div>
                            <div class='column'>
                                <br/>
                                <h3 class='title is-5'>{{post.university.name}}</h3>
                                <q>{{post.text}}</q>
                            </div>
                        </div>
                    </div>
                </div>

                <h3 class='subtitle is-4'>Looking for teammates</h3>
                <div class='columns'>
                    <div class='column' v-for="project in lookingForTeammates" :key="project.id">
                        <project-card :project="project"></project-card>
                    </div>
                </div>

                <br/>

                <!-- <h3 class='subtitle is-4'>Other highlights</h3>

                <div class='columns'>

                    <div class='column'>

                        <div class='columns'>
                            <div class='column'>
                                <div class="card">
                                  <div class="card-image">
                                    <figure class="image is-4by3">
                                      <img src="https://biaggiouploads.s3.amazonaws.com/a3c295f2-424e-44c2-b2dc-da87fbb0b7e8" alt="Project logo">
                                    </figure>
                                  </div>
                                  <div class="card-content">
                                    <div class="media">
                                      <div class="media-content">
                                          <b-message type="is-danger">
                                              abc has started their journey on Biaggeo
                                          </b-message>
                                          <b-message type="is-danger">
                                              abc is looking for a Software Developer
                                          </b-message>
                                        <p class="title is-4">abc</p>
                                      </div>
                                    </div>
                                    <div class="content">
                                      Matchmaking and crowdfunding site for student makers: inventors, innovators, builders, and entrepreneurs. Build a dream-team, get funded, succeed.
                                    </div>
                                  </div>
                                </div>
                            </div>
                            <div class='column'>
                                <div class="card">
                                  <div class="card-image">
                                    <figure class="image is-4by3">
                                      <img src="https://biaggiouploads.s3.amazonaws.com/a3c295f2-424e-44c2-b2dc-da87fbb0b7e8" alt="Project logo">
                                    </figure>
                                  </div>
                                  <div class="card-content">
                                    <div class="media">
                                      <div class="media-content">
                                          <b-message type="is-success">
                                              abc is now crowdfunding!<br/>
                                              <strong>Target</strong>: $5,000
                                          </b-message>
                                        <p class="title is-4">abc</p>
                                      </div>
                                    </div>
                                    <div class="content">
                                      Matchmaking and crowdfunding site for student makers: inventors, innovators, builders, and entrepreneurs. Build a dream-team, get funded, succeed.
                                    </div>
                                  </div>
                                </div>
                            </div>
                            <div class='column'>
                                <div class="card">
                                  <div class="card-image">
                                    <figure class="image is-4by3">
                                      <img src="https://biaggiouploads.s3.amazonaws.com/a3c295f2-424e-44c2-b2dc-da87fbb0b7e8" alt="Project logo">
                                    </figure>
                                  </div>
                                  <div class="card-content">
                                    <div class="media">
                                      <div class="media-content">
                                          <b-message type="is-info">
                                              abc has reached over 1,000 favorites!
                                          </b-message>
                                        <p class="title is-4">abc</p>
                                      </div>
                                    </div>
                                    <div class="content">
                                      Matchmaking and crowdfunding site for student makers: inventors, innovators, builders, and entrepreneurs. Build a dream-team, get funded, succeed.
                                    </div>
                                  </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div> -->

            </div>
        </div>
    </div>
</template>

<style scoped>
.card {
    margin: 8px;
    max-width: 300px;
}
q { font-style: italic; }
</style>

<script>
export default {
  name: 'Dashboard',
  data () {
    return {
      checklist: [
        { id: 0, completed: true, text: 'Do this thing' },
        { id: 1, completed: false, text: 'Do that thing' },
        { id: 2, completed: false, text: 'And another thing' }
      ],
      universitySpotlights: [], // [{ project: ..., post: ... }]
      lookingForTeammates: [] // array of projects
    }
  },
  mounted() {
    this.$http.get(this.$hostname + '/dashboard').then(function(response) {
      this.universitySpotlights = response.body.universitySpotlights;
      this.lookingForTeammates = response.body.lookingForTeammates;
    });
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Dashboard.vue